<div
  class="flex items-center mt-4 gap-2 pl-4 pr-2 rounded-[4px] bg-surface-container-lowest border w-[min(557px,calc(100vw-40px))] toast-shadow"
  [ngClass]="borderClass"
  [attr.data-testid]="'toast-' + toast.variant"
>
  <div class="flex items-start gap-2 py-3 flex-1 min-w-0">
    <mat-icon [svgIcon]="iconName" class="inline-flex !items-center !justify-center shrink-0 icon-size [--icon-size:20px]" [ngClass]="iconClass"></mat-icon>
    <p class="label-large text-on-primary-container m-0 flex-1 min-w-0">{{ toast.message }}@if (toast.action) {<span>&#160;</span><button
        type="button"
        class="label-large text-on-primary-container underline underline-offset-2 bg-transparent border-0 p-0 cursor-pointer"
        (click)="onActionClick()"
        data-testid="toast-action-button"
      >{{ toast.action.label }}</button>}</p>
  </div>
  @if (toast.dismissible) {
    <button
      mat-icon-button
      type="button"
      class="!w-8 !h-8 shrink-0"
      (click)="close.emit()"
      [attr.aria-label]="'Close'"
      data-testid="toast-close-button"
    >
      <mat-icon svgIcon="close-affordance" class="icon-size [--icon-size:40px]"></mat-icon>
    </button>
  }
</div>
